import { reactLocalStorage } from "reactjs-localstorage";
import { getCostingTypePermission } from '../../common/CommonFunctions';

export function Steps(t, config) {
    const permissions = getCostingTypePermission();
    const showSendForApprovalButton = config?.showSendForApproval !== undefined && config?.showSendForApproval === true
    const introMessage = (config && config.isEditFlag === false) ? t("DynamicActionControl.save_Button") : t("DynamicActionControl.update_Button");
    const EffectiveDate = (config && config.isEditFlag === false) ? t("operationMaster.AddOperation_EffectiveDate") : t("operationMaster.AddOperation_Edit_EffectiveDate");
    const Rate = (config && config.isEditFlag === false) ? t("operationMaster.AddOperation_Rate") : t("operationMaster.AddOperation_EditRate");
    const WeldingRate = (config && config.isEditFlag === false) ? t("operationMaster.AddOperation_WeldingRate_container") : t("operationMaster.AddOperation_EditWeldingRate_container");

    return {
        ADD_OPERATION: [
            ...(config && config.isEditFlag === false) ? [
                {
                    element: "#Add_operation_zero_based",
                    intro: t("operationMaster.Add_operation_zero_based"),
                },
                {
                    element: "#Add_operation_vendor_based",
                    intro: t("operationMaster.Add_operation_vendor_based"),
                },
                ...(permissions?.cbc ? [{
                    element: "#Add_operation_customer_based",
                    intro: t("operationMaster.Add_operation_customer_based"),
                }] : []),

                ...(config && config.IsShowOperationType ? [
                    {
                        element: "#AddOperation_operationType_container",
                        intro: t("operationMaster.AddOperation_operationType_container"),
                    }] : []),
                {
                    element: "#AddOperation_technology_container",
                    intro: t("operationMaster.AddOperation_technology_container"),
                },
                {
                    element: "#AddOperation_OperationName",
                    intro: t("operationMaster.AddOperation_OperationName"),
                },
                {
                    element: "#AddOperation_OperationCode",
                    intro: t("operationMaster.AddOperation_OperationCode"),
                },
            ] : [],
            {
                element: "#AddOperation_Description",
                intro: t("operationMaster.AddOperation_Description"),
            },
            ...(config && config.isEditFlag === false) ? [
                ...(config && config.vendorField ? [{

                    element: "#AddOperation_VendorCode",
                    intro: t("operationMaster.AddOperation_VendorCode"),
                },] : []),
                ...(config && config.vendorField && config?.isEditFlag === false ? [{

                    element: "#AddOperation_AddVendorCode",
                    intro: t("operationMaster.AddVendorCode"),
                },] : []),

                ...(config && config.destinationPlant ? [{

                    element: "#AddOperation_DestinationPlant_container",
                    intro: t("operationMaster.AddOperation_DestinationPlant_container"),
                },] : []),
                ...(config && config.plantField ? [{
                    element: "#AddOperation_DestinationPlant_container",
                    intro: t("operationMaster.AddOperation_Plant_container"),
                },] : []),

                ...(config && config.customerField ? [{
                    element: "#AddOperation_clientName_container",
                    intro: t("operationMaster.AddOperation_Customer_container"),
                },] : []),
            ] : [],
            {
                element: "#AddOperation_UnitOfMeasurementId_container",
                intro: t("operationMaster.AddOperation_UnitOfMeasurementId_container"),
            },
            ...(config && config.isEditFlag === true) ? [
                ...(config && config.isWelding ? [
                    {
                        element: "#AddOperation_WeldingRate",
                        intro: WeldingRate
                    },
                    {
                        element: "#AddOperation_Consumption",
                        intro: t("operationMaster.AddOperation_Consumption_container")
                    }] : []),
            ] : [],
            ...(config && !config.isWelding) ? [
                {
                    element: "#rate",
                    intro: Rate,
                }] : [],

            ...(config && config.isEditFlag === false) ? [
                {
                    element: "#AddOperation_LabourRatePerUOM",
                    intro: t("operationMaster.AddOperation_LabourRatePerUOM"),
                }] : [],

            {
                element: "#AddOperation_EffectiveDate",
                intro: EffectiveDate,
            },

            {
                element: "#AddOperation_SurfaceTreatmentCheckbox",
                intro: t("operationMaster.AddOperation_SurfaceTreatmentCheckbox"),
            },
            ...(config && config.isEditFlag === false) ? [
                {
                    element: "#AddMoreOperation_container",
                    intro: t("operationMaster.AddMoreOperation_container"),
                }] : [],
            {
                element: "#AddOperation_Remark",
                intro: t("operationMaster.AddOperation_Remark"),
            },
            {
                element: "#AddOperation_UploadFiles",
                intro: t("operationMaster.AddOperation_UploadFiles"),
            },
            {
                element: "#AddOperation_Cancel",
                intro: t("operationMaster.AddOperation_Cancel"),
            },
            ...((showSendForApprovalButton === false) ? [
                {
                    element: "#AddOperation_Save",
                    intro: introMessage,
                    position: 'left'
                },
            ] : []),
            ...((showSendForApprovalButton === true) ? [
                {
                    element: "#AddOperation_SendForApproval",
                    intro: t("operationMaster.AddOperation_SendForApproval"),
                    position: 'left'
                },
            ] : []),
        ],
    }
}